export default "__VITE_ASSET__BPUF_szl__"